import React from 'react';
import { motion } from 'framer-motion';
import { useFormModal } from './FormModal';
export function BeforeAfter() {
  const cases = [{
    beforeImg: 'https://cdn.magicpatterns.com/uploads/k2QTGRQYUxm2kNTENVQ5Rh/a1.png',
    afterImg: 'https://cdn.magicpatterns.com/uploads/iYRavumKq43fDJ2qPaww3L/d1.png',
    quote: 'I finally feel confident speaking in meetings.',
    name: 'Sarah M.',
    duration: '14 months'
  }, {
    beforeImg: 'https://cdn.magicpatterns.com/uploads/nqdqRzf66mGqVvWeV3kUwB/a2.png',
    afterImg: 'https://cdn.magicpatterns.com/uploads/kqaRnowB7de3UGZXMQAj9n/d2.png',
    quote: "Best investment I've ever made in myself.",
    name: 'David L.',
    duration: '12 months'
  }, {
    beforeImg: 'https://cdn.magicpatterns.com/uploads/q9MjWtTZ8dxTPP2NcsqBvV/a3.png',
    afterImg: 'https://cdn.magicpatterns.com/uploads/h5eNUUkZoEeMbqu3dSjY1u/d3.png',
    quote: "I wish I hadn't waited so long to do this!",
    name: 'Elena R.',
    duration: '18 months'
  }];
  const {
    openFormModal
  } = useFormModal();
  return <section className="py-10 lg:py-20 bg-brand-dark text-white" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="text-center max-w-3xl mx-auto mb-8 lg:mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-light mb-3 lg:mb-4" data-id="element-26">
            Real Smiles. Real Confidence.
          </h2>
          <p className="text-lg text-white/60" data-id="element-27">
            See the transformations of actual Lima Dental patients who chose
            Invisalign.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 lg:gap-8 mb-8 lg:mb-16" data-id="element-28">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 rounded-2xl p-3 lg:p-4 border border-white/10" data-id="element-29">
              <div className="flex flex-col gap-2 mb-4 lg:mb-6" data-id="element-30">
                <div className="relative h-36 lg:h-48 rounded-xl overflow-hidden border border-white/5" data-id="element-31">
                  <span className="absolute top-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded backdrop-blur-sm z-10" data-id="element-32">
                    Before
                  </span>
                  <img src={item.beforeImg} alt="Before treatment" className="w-full h-full object-cover" data-id="element-33" />
                </div>
                <div className="relative h-36 lg:h-48 rounded-xl overflow-hidden border border-white/10" data-id="element-34">
                  <span className="absolute top-2 left-2 bg-brand-cream text-brand-dark text-xs px-2 py-1 rounded font-medium z-10" data-id="element-35">
                    After
                  </span>
                  <img src={item.afterImg} alt="After treatment" className="w-full h-full object-cover" data-id="element-36" />
                </div>
              </div>

              <div className="px-2" data-id="element-37">
                <p className="text-base lg:text-lg italic text-brand-cream mb-2 lg:mb-3" data-id="element-38">
                  "{item.quote}"
                </p>
                <div className="flex justify-end text-xs lg:text-sm text-white/40" data-id="element-39">
                  <span data-id="element-40">Treatment: {item.duration}</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-41">
          <button onClick={openFormModal} className="bg-brand-cream hover:bg-white text-brand-dark font-medium py-4 px-8 rounded-full transition-colors text-lg" data-id="element-42">
            Start Your Transformation — Claim $3,000 Off
          </button>
        </div>
      </div>
    </section>;
}